import { DiscoverFields } from "./fields";
import { DiscoverConstants } from "./discoverConstants";

export const ReasonSpecifDetail = {
  all: {
    fields: [
      {
        fieldObject: DiscoverFields.documentationIndicator,
        isRequired: true,
        isParent: true,
        isDependant: true,
        parent: DiscoverFields.image,
        parentValue: false
      },
      {
        fieldObject: DiscoverFields.docType,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: [
          DiscoverConstants.DocumentationIndicators[1].value,
          DiscoverConstants.DocumentationIndicators[3].value
        ]
      },
      {
        fieldObject: DiscoverFields.image,
        isParent: true,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: false
      },
      {
        fieldObject: DiscoverFields.cashOverOption,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.cashOverReason,
        isDependant: true,
        isHidden: false,
        isRequired: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[1].value,
          DiscoverConstants.CashOverOptions[2].value
        ]
      }
    ]
  },
  reasonDetail01: {
    description: "Transaction Documentation Request",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetail03: {
    description: "Transaction Documentation Request Due to Cardholder Dispute",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      }
    ]
  },
  reasonDetail04: {
    description: "Transaction Documentation Request for Fraud Analysis",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetail05: {
    description: "Good Faith Investigation",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailAA: {
    description: "Does Not Recognize",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailAP: {
    description: "Recurring Payment",
    isRecurrent: true,
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: {
          ...DiscoverFields.cancellationOrReturnReason,
          label: "Cancellation Reason"
        },
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationDate,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationMethod,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerName,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerNumber,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cancellationNumber,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailAT: {
    description: "Authorization Non Compliance",
    fields: [
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailAW: {
    description: "Altered Amount",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.correctAmount,
        isRequired: false,
        cashBackValidation: {
          mandatoryforCashBack: false
        }
      },
      {
        fieldObject: DiscoverFields.merchandiseCorrectAmount,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[0].value,
          DiscoverConstants.CashOverOptions[2].value
        ],
        cashBackValidation: {
          mandatoryforCashBack: true
        }
      },
      {
        fieldObject: DiscoverFields.cashOverCorrectAmount,
        isRequired: true,
        isDependant: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [
          DiscoverConstants.CashOverOptions[1].value,
          DiscoverConstants.CashOverOptions[2].value
        ],
        cashBackValidation: {
          mandatoryforCashBack: true
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: [DiscoverConstants.DocumentationIndicators[3].value]
      }
    ]
  },
  reasonDetailCD: {
    description: "Credit/Debit Posted Incorrectly",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: [DiscoverConstants.DocumentationIndicators[3].value]
      }
    ]
  },
  reasonDetailDP: {
    description: "Duplicate Processing",
    isDuplicate: true,
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      }
    ]
  },
  reasonDetailIN: {
    description: "Invalid Cardholder Number",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  },
  reasonDetailLP: {
    description: "Late Presentation",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailNF: {
    description: "Non Receipt of Cash From ATM",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailPM: {
    description: "Paid By Other Means",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailRG: {
    description: "Non-Receipt of Goods or Services",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.merchandiseDescription,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.orderCancelled,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.cancellationDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationMethod,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerName,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancellationNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.orderCancelled,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.promisedDeliveryDate,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailRM: {
    description: "Cardholder Disputes Quality of Goods or Services",
    fields: [
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isDependant: true,
        isRequired: true,
        parent: DiscoverFields.documentationIndicator,
        parentValue: [DiscoverConstants.DocumentationIndicators[3].value]
      }
    ]
  },
  reasonDetailRN2: {
    description: "Credit Not Processed",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.benCaseIndicator,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.benDueDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.benReceivedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.benCaseIndicator,
        parentValue: true
      },
      {
        fieldObject: DiscoverFields.cancelledOrReturned,
        isRequired: true,
        isParent: true
      },
      {
        fieldObject: DiscoverFields.returnedDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[1].value]
      },
      {
        fieldObject: DiscoverFields.returnMethod,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[1].value]
      },
      {
        fieldObject: DiscoverFields.cancellationDate,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.cancellationMethod,
        isDependant: true,
        isHidden: true,
        isRequired: true,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.reason,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerName,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.cancellationHandlerNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.cancellationNumber,
        isDependant: true,
        isHidden: true,
        isRequired: false,
        parent: DiscoverFields.cancelledOrReturned,
        parentValue: [DiscoverConstants.CancelledOrReturned[0].value]
      },
      {
        fieldObject: DiscoverFields.merchandiseServiceDescription,
        isRequired: true
      },

      {
        fieldObject: DiscoverFields.reservationDate,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.creditReceiptDate,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailTF: {
    description: "Violation of Operating Regulations",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.dateOfViolation,
        isRequired: false
      }
    ]
  },
  reasonDetailUA01: {
    description: "Fraud Card Present Transaction",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  },
  reasonDetailUA02: {
    description: "Fraud Card Not Present Transaction",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      }
    ]
  },
  reasonDetailUA05: {
    description: "Fraud Chip Card Counterfeit Transaction",
    fields: [
      {
        fieldObject: DiscoverFields.authorizationApproved,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.fraud,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cardPresentAtTransactionTime,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.confirmedFraudFile,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailUA06: {
    description: "Fraud Chip Card and PIN Transaction",
    fields: [
      {
        fieldObject: DiscoverFields.authorizationApproved,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.accountClosed,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.cardPresentAtTransactionTime,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.confirmedFraudFile,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.pinEnabled,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.authorizationServiceCode,
        isRequired: true
      },
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  },
  reasonDetailDC: {
    description: "Disputes Compliance",
    fields: [
      {
        fieldObject: DiscoverFields.disputeAmount,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cashOverAmount,
        isDependant: true,
        isRequired: false,
        isHidden: true,
        parent: DiscoverFields.cashOverOption,
        parentValue: [DiscoverConstants.CashOverOptions[2].value],
        cashBackValidation: {
          forCashBack: true,
          greaterThan: false
        }
      },
      {
        fieldObject: DiscoverFields.noticeComment,
        isRequired: false
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/configurations/discoverConfigs/reasonCodes.js